// import { ValiError } from 'valibot';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { AddressApiItem, AddressBookSearchApiResponse, AddressSearchParams } from '../../models';
import * as mock from './mock';

export const fetchTimeZones = (_options: { signal?: AbortController['signal'] } = {}) => mock.fetchTimeZones(_options);

// Address Book
export const fetchAddressBookSearch = async (
  params: AddressSearchParams,
  options: { signal?: AbortController['signal'] } = {},
) => {
  const { address1, address2, country, name, state, postalCode, city, limit = 10, offset = 0, sorting } = params;

  const response = await axiosInstance.request<AddressBookSearchApiResponse>({
    method: 'get',
    params: {
      Address1: address1 || undefined,
      Address2: address2 || undefined,
      City: city || undefined,
      CountryCode: country?.id ?? undefined,
      Name: name || undefined,
      PostalCode: postalCode || undefined,
      Skip: offset,
      Sorting: sorting || undefined,
      StateCode: state?.id ?? undefined,
      Take: limit,
    },
    signal: options.signal,
    url: `${API.BASE}/address-book/search`,
  });

  const { items = [], totalCount = 0 } = response.data ?? {};

  return {
    data: items.map((item) => ({
      address1: item.address1 ?? '',
      address2: item.address2 ?? '',
      city: item.city ?? '',
      country: item.country ?? '',
      countryCode: item.countryCode ?? '',
      id: String(item.id ?? ''),
      name: item.name,
      postalCode: item.postalCode ?? '',
      state: item.state ?? '',
      stateCode: item.stateCode ?? '',
    })),
    total: totalCount,
  };
};

export const addAddress = async (payload: AddressApiItem, options: { signal?: AbortController['signal'] } = {}) => {
  const response = await axiosInstance.request<AddressApiItem>({
    data: payload,
    method: 'post',
    signal: options.signal,
    url: `${API.BASE}/address-book`,
  });

  return response.data;
};

export const fetchAddressById = async (id: string, options: { signal?: AbortController['signal'] } = {}) => {
  const response = await axiosInstance.request({
    method: 'get',
    signal: options.signal,
    url: `${API.BASE}/address-book/${id}`,
  });

  return response.data;
};

export const updateAddress = async (payload: AddressApiItem, options: { signal?: AbortController['signal'] } = {}) => {
  const response = await axiosInstance.request({
    data: payload,
    method: 'put',
    signal: options.signal,
    url: `${API.BASE}/address-book`,
  });

  return response.data;
};

export const deleteAddress = async (id: string, options: { signal?: AbortController['signal'] } = {}) => {
  const response = await axiosInstance.request({
    method: 'delete',
    signal: options.signal,
    url: `${API.BASE}/address-book/${id}`,
  });

  return response.data;
};
